<template>
   <li >
      <a href="#" v-on:click.prevent="show = !show">{{scriptItem.name}}</a>
      <ul v-if="show">
        <li v-for="(scr, subIndex) in scriptItem.oparatorScript" :key="subIndex">
<!--          <a :href="'/editScripts/' + scr.id">{{scr.name}}</a>-->
          <router-link :to="'/editScripts/' + scr.id" >{{scr.name}}</router-link>
        </li>
      </ul>
    </li>


</template>

<script>
  export default {
    name: "adminScriptsMenu",
    data(){
      return {
        show:false,
      }
    },
    props:{
      scriptID:{
        type:String,
        default:'1',
      },
      scriptItem:{
        type:Object,
        default:()=>{
          return {}
        },
      }
    }
  }
</script>

<style scoped>
li{margin: 5px 0;}

</style>
